import React, { useContext } from "react";
import { SiteStateContext } from "./SiteStateContext";

const StatusModule = ({ compact = false }) => {
  const { status, setStatus } = useContext(SiteStateContext);

  const handleStatusChange = (newStatus) => {
    setStatus(newStatus);
    // provider’s useEffect will handle localStorage syncing
  };

  const containerStyle = compact
    ? { ...styles.container, padding: "0", margin: "0 auto" }
    : styles.container;
  const statusStyle = compact
    ? { ...styles.status, marginTop: 0, marginBottom: "0.35rem", lineHeight: 1.2 }
    : styles.status;
  const buttonStyle = compact ? { ...styles.button, padding: "0.35rem 0.8rem" } : styles.button;

  return (
    <div style={containerStyle}>
      <p style={statusStyle}>{status}</p>
      <div style={styles.buttonGroup}>
        <button onClick={() => handleStatusChange("All Scans")} style={buttonStyle}>
          All
        </button>
        <button onClick={() => handleStatusChange("Team Scans")} style={buttonStyle}>
          Team
        </button>
        <button onClick={() => handleStatusChange("Private Scans")} style={buttonStyle}>
          Private
        </button>
      </div>
    </div>
  );
};

const styles = {
  container: {
    color: "var(--theme-text-color)",
    padding: "1rem",
    borderRadius: "8px",
    textAlign: "center",
    maxWidth: "300px",
    margin: "1rem auto",
  },
  status: {
    fontWeight: "bold",
    marginBottom: "1rem",
  },
  buttonGroup: {
    display: "flex",
    justifyContent: "center",
    gap: "0.5rem",
  },
  button: {
    padding: "0.5rem 1rem",
    backgroundColor: "var(--theme-color)",
    border: "none",
    borderRadius: "4px",
    color: "var(--theme-text-color)",
    cursor: "pointer",
  },
};

export default StatusModule;
